import { CUSTOMER_FILE_TYPE } from "v4/data/fieldTypes";

export default class FileDTO {
    constructor({
                    id = null,
                    label = '',
                    mimeType = null,
                    downloadLink = null,
                    file = null,
                    shouldDelete = false,
                    isQuotePdf = false,
                    error = null,
                    type = CUSTOMER_FILE_TYPE,
                }) {
        this.id = id;
        this.label = label;
        this.mimeType = mimeType;
        this.downloadLink = downloadLink;
        this.file = file;
        this.shouldDelete = shouldDelete;
        this.isQuotePdf = isQuotePdf;
        this.error = error;
        this.type = type;
    }

    static fromServer(raw, { type } = {}) {
        return new FileDTO({
            id: raw.id ?? null,
            label: raw.fileLabel ?? raw.realFileName ?? '',
            mimeType: raw.mimeType ?? null,
            downloadLink: raw.downloadLink ?? null,
            isQuotePdf: !!raw.quotePdf,
            type,
        });
    }

    static fromFile(file, { type, error = null } = {}) {
        return new FileDTO({
            label: file.name,
            mimeType: file.type || null,
            file,
            error,
            type,
        });
    }

    static normalize(value, { type } = {}) {
        if (!value) return [];
        if (!Array.isArray(value)) return [FileDTO.fromServer(value, { type })];

        return value.map(raw => raw instanceof FileDTO ? raw : FileDTO.fromServer(raw, { type }));
    }

    get isNew() {
        return this.file !== null;
    }

    withShouldDelete(shouldDelete) {
        return new FileDTO({ ...this, shouldDelete });
    }

    withError(error) {
        return new FileDTO({ ...this, error });
    }

    appendToFormData(formData, path) {
        if (this.isNew) {
            if (this.type === CUSTOMER_FILE_TYPE) {
                formData.append(`${path}[customerFile][file]`, this.file);
                return;
            }
            formData.append(path, this.file);
            return;
        }

        if (this.shouldDelete) {
            formData.append(`${path}[shouldDelete]`, 'true');
        }
    }
}

export function appendFileField(formData, key, dtos, { multiple = false } = {}) {
    if (!multiple) {
        dtos.forEach(dto => dto.appendToFormData(formData, key));
        return;
    }

    dtos.forEach((dto, index) => {
        dto.appendToFormData(formData, dto.isNew ? `${key}[]` : `${key}[${index}]`);
    });
}

export function isFileDTOList(value) {
    return Array.isArray(value) && value.some(item => item instanceof FileDTO);
}

export function hasFileErrors(dtos) {
    return dtos.some(({ error }) => !!error);
}
